<template>
  <div class="navbarMobile">
    <div class="topContainer">
      <button id="buttonMobile" @click="handleOpenNav()">
        <b-icon pack="fas" icon="bars" type="white" />
      </button>
    </div>
    <nav class="navHidden" :class="{ navOpened: openNavbar }">
      <navbar-logo id="logo">
        <img src="../../../assets/logo.png" alt="logo" />
      </navbar-logo>
      <div id="bodyNavbar">
        <navbar-item
          icon="home"
          name="Dashboard"
          to="/dashboard"
          v-if="haveClient"
        />
        <navbar-group
          icon="bullhorn"
          name="Marketing"
          :routes="marketingRoutes"
          :navIsOpen="openNavbar"
        >
          <ul>
            <li>
              <router-link
                to="/videos"
                v-if="haveClientNotGroup"
                class="subItens"
                >Campanhas</router-link
              >
            </li>
            <li>
              <router-link
                to="/perguntas"
                v-if="haveClientNotGroup"
                class="subItens"
                >Enquetes</router-link
              >
            </li>
            <li>
              <router-link to="/sms" class="subItens">SMS</router-link>
            </li>
            <li>
              <router-link
                to="/emails"
                v-if="haveClientNotGroup"
                class="subItens"
                >E-mail</router-link
              >
            </li>
          </ul>
        </navbar-group>
        <navbar-group
          icon="wifi"
          name="WiFi"
          :routes="wifiRoutes"
          class="subItens"
          :navIsOpen="openNavbar"
        >
          <ul>
            <li>
              <router-link
                to="/radios"
                v-if="haveClientNotGroup"
                class="subItens"
                >Vagalumes</router-link
              >
            </li>
            <li>
              <router-link
                class="subItens"
                to="/voucher"
                v-if="haveClientNotGroup"
                >Voucher</router-link
              >
            </li>
          </ul>
        </navbar-group>
        <navbar-group
          icon="lightbulb"
          name="Insight"
          :routes="insightRoutes"
          :navIsOpen="openNavbar"
        >
          <ul>
            <li>
              <router-link to="/maps" v-if="clientHasMap" class="subItens"
                >Mapas</router-link
              >
            </li>
            <!--   <li>
              <router-link to="/maps" class="subItens"
                >Aniversariantes</router-link
              >
            </li> -->
            <li>
              <router-link
                to="/acessos"
                v-if="haveClientNotGroup"
                class="subItens"
                >Público</router-link
              >
            </li>
            <li>
              <router-link
                to="/recurrence"
                v-if="haveClientNotGroup"
                class="subItens"
                >Recorrencia</router-link
              >
            </li>
          </ul>
        </navbar-group>
        <navbar-group
          icon="cogs"
          name="Administrar"
          :routes="admRoutes"
          :navIsOpen="openNavbar"
        >
          <ul>
            <li>
              <router-link to="/clientes" v-if="isROOT" class="subItens"
                >Cliente</router-link
              >
            </li>
            <li>
              <router-link to="/usuarios" v-if="isADM" class="subItens"
                >Usuários</router-link
              >
            </li>
            <li>
              <router-link to="/settings" class="subItens"
                >Configurações</router-link
              >
            </li>
            <li>
              <router-link to="/notifications" v-if="isADM" class="subItens"
                >Alerta</router-link
              >
            </li>
            <li>
              <a
                href="http://helpdesk.vagalumewifi.com.br/glpi/"
                v-if="isADM"
                class="subItens"
                >Suporte</a
              >
            </li>
            <li>
              <a @click="exit()" class="subItens">Sair </a>
            </li>
          </ul>
        </navbar-group>

        <modal-client />
      </div>
    </nav>
  </div>
</template>

<script>
import navbarItem from "./navbarItem.vue";
import navbarGroup from "./navbarGroup.vue";
import navbarLogo from "./navbarLogo.vue";
import modalClient from "../sidebar/modalClient.vue";
import { getPageName } from "@/functions/pathsName.js";
import Webservices from "@/Webservices";
import store from "@/store";
import { mapActions, mapGetters, mapState } from "vuex";
import TimeMe from "timeme.js";

const ws = new Webservices();

export default {
  components: {
    navbarItem,
    navbarGroup,
    navbarLogo,
    modalClient
  },
  data() {
    return {
      openNavbar: false,
      exibe_bar: true,
      marketingRoutes: ["/videos", "/perguntas"],
      wifiRoutes: ["/radios", "/Publico", "/Recurrence"],
      insightRoutes: ["/maps", "/birthday"],
      admRoutes: ["/clientes", "/usuarios", "/settings", "/notifications"]
    };
  },

  created() {
    ws.updateAccessToken(this.getToken);
    this.loadClient();

    window.addEventListener("beforeunload", this.unloadWindowActions);

    this.initTimers();
  },
  computed: {
    ...mapState({
      client: state => state.client,
      group: state => state.group
    }),
    ...mapGetters([
      "isLoggedIn",
      "getCurrentPage",
      "getCurrentModal",
      "getName",
      "isADM",
      "getPhoto",
      "isDark",
      "getClient",
      "getClientName",
      "getClientLogo",
      "isROOT",
      "getRules",
      "getClients",
      "getClientID",
      "getClientsByGroupId",
      "getClientsByGroupIdShort",
      "getGroupsByFatherId",
      "getToken"
    ]),
    photoData() {
      return this.getPhoto;
    },
    haveClient() {
      if (store.state.client) {
        return store.state.client.id != null;
      } else {
        return false;
      }
    },
    haveClientNotGroup() {
      return (
        store.state.client &&
        store.state.client.id != null &&
        store.state.client.id != "all"
      );
    },
    clientHasMap() {
      return store.state.client && store.state.client.coordinates != null;
    },
    clientHasNotifications() {
      return store.state.client && store.state.client.mapActive != null;
    },
    getOpenNav() {
      if (this.openNav) {
        return (this.openNavbar = true);
      } else {
        return (this.openNavbar = false);
      }
    }
  },
  watch: {
    isROOT() {
      if (this.isROOT) {
        this.getSchoolGroup().then(() => {
          this.choiceGroup(this.selectedGroupList[0].id).then(() => {
            if (this.clientList[0].id == "all") {
              this.choiceClient(this.clientList[1].id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          });
        });
      }
    },
    $route(to, from) {
      this.openNavbar = !this.openNavbar;
    },
    getCurrentPage(page) {
      TimeMe.stopAllTimers();
      TimeMe.startTimer(page);
    },

    getCurrentModal(modal) {
      TimeMe.stopAllTimers();
      if (modal === undefined) {
        const path = this.$router.currentRoute.path;
        const page = getPageName(path);

        TimeMe.startTimer(page);
      } else {
        TimeMe.startTimer(modal);
      }
    }
  },
  mounted() {
    if (this.isROOT) {
      this.getSchoolGroup().then(() => {
        this.choiceGroup(this.selectedGroupList[0].id).then(() => {
          if (this.clientList[0].id == "all") {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[1].id);
            }
          } else {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          }
        });
      });
    }
  },

  methods: {
    ...mapActions(["logout", "selectClient"]),
    handleOpenNav() {
      this.openNavbar = !this.openNavbar;
    },
    //Estudar alguma forma de mandar esses dados periodicamente
    //Atualmente os dados são enviados em LOGOUT/FECHAR ABA/MUDAR PARA OUTRA PAGINA/TROCA DE CLIENTE
    /* sendTimeData(client_id) {
      TimeMe.stopAllTimers();
      const time_per_page = TimeMe.getTimeOnAllPagesInSeconds();

      this.initTimers();

      //Vai dar return quando o cliente inicial ainda não foi definido
      if (client_id == undefined) return;

      const { userId: user_id } = JSON.parse(localStorage.getItem("data"));

      let dataToSend = {
        user_id,
        client_id,
        time_per_page,
        datetime: new Date().toISOString()
      };

      ws.sendTimePerPage(dataToSend);
    }, */

    //Reinicializa os cronometros
    initTimers() {
      const path = this.$router.currentRoute.path;

      TimeMe.resetAllRecordedPageTimes();
      TimeMe.initialize({
        idleTimeoutInSeconds: 600,
        currentPageName: getPageName(path)
      });
    },
    unloadWindowActions() {
      //TROCAR O NOME DO LOCAL STORAGE PARA ALGO MENOS GENERICO
      const { client } = JSON.parse(localStorage.getItem("data"));
      let clientId = client != undefined ? client.controller_id : undefined;

      /*  this.sendTimeData(clientId); */
    },
    choiceClient(clientId) {
      if (clientId == "all") {
        var client = {
          id: "all",
          name: "todos",
          controller_id: "all"
        };
      } else {
        var client = this.getClients.find(el => el.id == clientId);
      }
      //this.selectedClient = "5ed817c8b3a856200a282f3a"
      this.exibe_bar = false;
      //this.exib_client_list = false
      setTimeout(() => {
        this.exibe_bar = true;
        //this.exib_client_list = true;
      }, 250);
      store.state.group_client_await = false;
      this.selectClient(client);

      //Atualiza a informacao do ultimo cliente selecionado
      this.lastSelectedClient = this.currentSelectedClient;

      const { client: client_info } = JSON.parse(localStorage.getItem("data"));
      this.currentSelectedClient =
        client_info != undefined ? client_info.controller_id : undefined;
      this.openModalAdm = false;
    },
    closeDialog() {
      this.dialogImport = false;
      this.dateSD = "";
      this.dateED = "";
      this.start_date = "";
      this.end_date = "";
    },
    loadClient() {
      ws.getClientsByGroupId(store.state.groupId).then(res => {
        //console.log("res.data[0].id: ",res.data[0].id )
      });
    },
    getSchoolGroup() {
      return new Promise((resolve, reject) => {
        var groups = [];
        ws.getGroups().then(res => {
          var groups_ = res.data;
          var fathers = [];
          groups_.forEach(group => {
            if (fathers.indexOf(group.father_id) === -1) {
              fathers.push(group.father_id);
            }
          });

          groups_.forEach(group => {
            if (fathers.indexOf(group.id) === -1 || group.id != 99) {
              groups.push(group);
            }
          });

          this.selectedGroupList = groups;
          resolve(1);
        });
      });
    },
    choiceGroup(groupId) {
      this.exib_client_list = false;
      if (store.state.client) {
        store.state.client.ex_id = store.state.client.id;
        //store.state.client.id = "123";
      }

      return new Promise((resolve, reject) => {
        ws.getGroups().then(res => {
          this.selectedGroup = res.data.find(el => el.id == groupId);
          this.getClientsFromGroup().then(() => {
            resolve(1);
          });
        });
      });
    },
    getGroupList() {
      return this.selectedGroupList;
    },
    getClientsFromGroup() {
      store.state.group_client_await = true;
      return new Promise((resolve, reject) => {
        ws.getClientsByGroupIdShort(this.selectedGroup.id).then(resp => {
          this.exib_client_list = false;
          if (resp.data.length > 1) {
            this.exibe_bar = false;
            this.selectClient(resp.data[0]);
            setTimeout(() => {
              this.exibe_bar = true;
            }, 250);
            this.selectedClient = resp.data[0].id;
            store.state.group_client_await = false;
            this.clientList = [];
            for (let cliente of resp.data) {
              this.clientList.push({
                name: cliente.name,
                id: cliente.id
              });
            }
            this.clientList.unshift({
              name: "Todos",
              id: "all",
              radio_prefix: "all"
            });
          } else {
            this.clientList = resp.data;
            if (resp.data.length) {
              this.selectClient(resp.data[0]);
              this.selectedClient = resp.data[0].id;
              store.state.group_client_await = false;
            }
            //this.exib_client_list = true;
          }
          store.state.group_selected_clients = resp.data;
          store.state.group_selected = this.selectedGroup;
          setTimeout(() => {
            this.exib_client_list = true;
          }, 1000);
          resolve(1);
        });
      });
    },
    exit() {
      /*  this.sendTimeData(); */
      this.logout();
      this.$router.push("/login");
    },
    items(isAdm, isRoot) {
      var saida = [];
      var self = this;

      if (isAdm && isRoot) {
        saida = [
          {
            id: "1",
            title: "Clientes",
            icon: "business",
            path: "clientes",
            disabled: false
          },
          {
            id: "2",
            title: "Usuários",
            icon: "supervisor_account",
            path: "usuarios",
            disabled: false
          },
          {
            id: "3",
            title: "Configurações",
            icon: "settings",
            path: "admSettings",
            disabled: false
          },
          {
            id: "4",
            title: "Overview",
            icon: "remove_red_eye",
            path: "/overview",
            disabled: false
          },
          {
            id: "4_1",
            title: "divider"
          },
          {
            id: "5",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard_adm",
            disabled: !this.haveClient
          },
          {
            id: "6",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/admVoucher",
            disabled: !this.haveClient
          },
          {
            id: "7",
            title: "Perguntas",
            icon: "assignment",
            path: "/admPerguntas",
            admArea: true,
            disabled: false
          },
          {
            id: "8",
            title: "Mídias",
            icon: "local_movies",
            path: "/admVideos",
            admArea: true,
            disabled: false
          },
          {
            id: "9",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "/admPessoas",
            admArea: true,
            disabled: !this.haveClient
          },
          {
            id: "10",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "11",
            title: "Email",
            icon: "Email",
            path: "/emails",
            disabled: !this.haveClient
          },
          {
            id: "12",
            title: "Birthday ",
            icon: "Email",
            path: "/birthday ",
            disabled: !this.haveClient
          },
          {
            id: "13",
            title: "Sms",
            icon: "vpn_lock",
            path: "/sms",
            disabled: !this.haveClient
          },
          {
            id: "14",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      } else if (isAdm && !isRoot) {
        saida = [
          {
            id: "1",
            title: "Overview",
            icon: "remove_red_eye",
            path: "/overview",
            disabled: false
          },
          {
            id: "1_1",
            title: "Usuários",
            icon: "supervisor_account",
            path: "/usuarios",
            disabled: false
          },
          {
            id: "2",
            title: "Configurações",
            icon: "settings",
            path: "admSettings",
            disabled: false
          },
          {
            id: "2_1",
            title: "divider"
          },
          {
            id: "3",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard_adm",
            disabled: !this.haveClient
          },
          {
            id: "4",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/admVoucher",
            disabled: !this.haveClient
          },

          {
            id: "5",
            title: "Perguntas",
            icon: "assignment",
            path: "/admPerguntas",
            admArea: true,
            disabled: false
          },
          {
            id: "6",
            title: "Mídias",
            icon: "local_movies",
            path: "/admVideos",
            admArea: true,
            disabled: false
          },
          {
            id: "7",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "/admPessoas",
            admArea: true,
            disabled: !this.haveClient
          },
          {
            id: "8",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "9",
            title: "Email",
            icon: "vpn_lock",
            path: "/emails",
            disabled: !this.haveClient
          },
          {
            id: "10",
            title: "Birthday",
            icon: "vpn_lock",
            path: "/birthday",
            disabled: !this.haveClient
          },
          {
            id: "11",
            title: "Sms",
            icon: "vpn_lock",
            path: "/sms",
            disabled: !this.haveClient
          },
          {
            id: "12",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      } else {
        saida = [
          {
            id: "1",
            title: "Dashboard",
            icon: "dashboard",
            path: "dashboard",
            admArea: false,
            disabled: !this.getRules.dashboard.list
          },
          {
            id: "2",
            title: "Mídias",
            icon: "local_movies",
            path: "videos",
            admArea: false,
            disabled: !this.getRules.videos.list
          },
          {
            id: "3",
            title: "Perguntas",
            icon: "assignment",
            path: "perguntas",
            admArea: false,
            disabled: !this.getRules.questions.list
          },
          {
            id: "4",
            title: "Acessos Wi-Fi",
            icon: "mobile_friendly",
            path: "publico",
            admArea: false,
            disabled: !this.getRules.acessos.list
          },
          {
            id: "5",
            title: "Configurações",
            icon: "settings",
            path: "settings",
            disabled: false
          },
          {
            id: "6",
            title: "Voucher",
            icon: "vpn_lock",
            path: "/voucher",
            disabled: !this.getRules.vouchers.list
          },
          {
            id: "7",
            title: "Vagalumes",
            icon: "vpn_lock",
            path: "/radios",
            disabled: !this.haveClient
          },
          {
            id: "8",
            title: "Email",
            icon: "vpn_lock",
            path: "/emails",
            disabled: false
          },
          {
            id: "9",
            title: "Birthday ",
            icon: "vpn_lock",
            path: "/birthday",
            disabled: false
          },
          {
            id: "10",
            title: "Sms",
            icon: "vpn_lock",
            path: "/sms",
            disabled: !this.haveClient
          },
          {
            id: "12",
            title: "Recurrence",
            icon: "vpn_lock",
            path: "/recurrence",
            disabled: !this.haveClient
          }
        ];
      }

      return saida;
    },
    action(item) {
      if (item.hasOwnProperty("action")) item.action();
    }
  }
};
</script>

<style lang="scss">
.navbarMobile {
  display: block;
  z-index: 100;
  height: 100px;
  width: 100vw;
  padding-top: 0px;
}
.topContainer {
  position: fixed;
  height: 50px;
  width: 100vw;
  background-color: #424242;
  display: flex;
  align-items: center;
  top: 0px;
  z-index: 100;
}
#buttonMobile {
  padding: 0px 5px;
  cursor: pointer;
  color: wheat;
  height: 100%;
}
.navHidden {
  visibility: hidden;
  max-height: 0;
  transition: max-height 0.5s;
}
.navOpened {
  z-index: 100;
  top: 50px;
  position: fixed;
  visibility: visible;
  background-color: #424242;
  width: 100vw;
  max-height: 100%;
  transition: max-height 0.5s;
}
.navBar {
  z-index: 1000;
  position: fixed;
  height: 100vh;
  width: 55px;
  background-color: #424242;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  transition: width 0.5s;
}

#bodyNavbar {
  display: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-box-shadow: 1px 8px 7px 0px rgba(50, 50, 50, 0.6);
  -moz-box-shadow: 1px 8px 7px 0px rgba(50, 50, 50, 0.6);
  box-shadow: 1px 8px 7px 0px rgba(50, 50, 50, 0.6);
}

.subItens {
  color: white;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/navbarMobile/navbarMobile.vue